import { useHttpClient } from '@wix/cli-http-client-react';
import { devMetadataSchema } from '@wix/cli-astro-definitions';
import { useAsyncCallback } from '@wix/cli-ui-kit';

export function useFetchDevMetadata() {
  const http = useHttpClient({ type: 'standalone' });

  return useAsyncCallback(async (_, serverLocalUrl: string) => {
    const url = new URL('/_wix/dev-metadata.json', serverLocalUrl);
    try {
      const { data } = await http.get(url.toString());
      return {
        devMetadata: devMetadataSchema.parse(data),
        serverLocalUrl,
      };
    } catch {
      return {
        devMetadata: null,
        serverLocalUrl,
      };
    }
  });
}
